export enum Slug {
    COLLECTION = "collection",
    BRAND = "brand",
    ORDER = "order",
    SHARE = "share",
    REPLENISHMENT = "replenishment",
}
